/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PrimaryInputs */

const en_primary = /** @type {(inputs: PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary`)
};

const es_primary = /** @type {(inputs: PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principal`)
};

const fr_primary = /** @type {(inputs: PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principale`)
};

const de_primary = /** @type {(inputs: PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primär`)
};

const ja_primary = /** @type {(inputs: PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メイン`)
};

const zh_primary = /** @type {(inputs: PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主图`)
};

const ar_primary = /** @type {(inputs: PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رئيسية`)
};

const id_primary = /** @type {(inputs: PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utama`)
};

const it_primary = /** @type {(inputs: PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principale`)
};

const ru_primary = /** @type {(inputs: PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Основное`)
};

const pt_primary = /** @type {(inputs: PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principal`)
};

const ko_primary = /** @type {(inputs: PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대표`)
};

/**
* | output |
* | --- |
* | "Primary" |
*
* @param {PrimaryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const primary = /** @type {((inputs?: PrimaryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PrimaryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_primary(inputs)
	if (locale === "es") return es_primary(inputs)
	if (locale === "fr") return fr_primary(inputs)
	if (locale === "de") return de_primary(inputs)
	if (locale === "ja") return ja_primary(inputs)
	if (locale === "zh") return zh_primary(inputs)
	if (locale === "ar") return ar_primary(inputs)
	if (locale === "id") return id_primary(inputs)
	if (locale === "it") return it_primary(inputs)
	if (locale === "ru") return ru_primary(inputs)
	if (locale === "pt") return pt_primary(inputs)
	return ko_primary(inputs)
});